import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const ConfirmDeleteDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: 360,
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle>削除の確認</DialogTitle>
      <DialogContent>
        <Typography>本当に削除しますか？</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            e.stopPropagation(); // イベント伝播を止める
            e.preventDefault(); // リンク遷移を防ぐ
            onClose(); // ダイアログを閉じる処理
          }}
          color="primary"
        >
          キャンセル
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation(); // イベント伝播を止める
            e.preventDefault(); // リンク遷移を防ぐ
            onConfirm(); // 実際の削除処理を呼ぶ
          }}
          color="error"
          variant="contained"
        >
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
